'use client';

import { Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface ProductSummaryRowProps {
  brand: string;
  productName: string;
  /** 표시용 가격 문자열 (예: "80,000원") */
  price: string;
  imageUrl: string;
  imageAlt?: string;
  /** 썸네일 비율 — 29CM=square(5:5), 무신사=portrait(세로). 서비스별 상이. (SID-4427) */
  imageRatio?: 'square' | 'portrait';
  className?: string;
}

export const ProductSummaryRow = ({
  brand,
  productName,
  price,
  imageUrl,
  imageAlt,
  imageRatio = 'portrait',
  className,
}: ProductSummaryRowProps) => (
  <div className={twMerge('flex items-center px-[16px]! py-[8px]! gap-[12px]', className)}>
    {/* 썸네일 비율 — 29CM 5:5(72x72) / 무신사 세로(72x86). (SID-4427) */}
    <div
      className={twMerge(
        'w-[72px] flex-shrink-0 overflow-hidden rounded-[2px] bg-gray-100',
        imageRatio === 'square' ? 'h-[72px]' : 'h-[86px]',
      )}
    >
      {imageUrl && (
        // biome-ignore lint/performance/noImgElement: dev mock — bypassing Next.js Image
        <img src={imageUrl} alt={imageAlt ?? productName} className="h-full w-full object-cover" />
      )}
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
      <Typography variant="body13pxSemi" colorScheme="black">
        {brand}
      </Typography>
      <Typography variant="body13pxReg" colorScheme="gray-700" className="line-clamp-2">
        {productName}
      </Typography>
      <Typography variant="body13pxSemi" colorScheme="black" className="mt-[4px]!">
        {price}
      </Typography>
    </div>
  </div>
);
